import { getLocalTimeZone, today } from '@internationalized/date';

import type { DateRangeValue } from '../index';

export type DateRangePreset = {
  key: string;
  label: string;
  value: DateRangeValue;
};

export function getPastDateRangePresets(): DateRangePreset[] {
  const currentDate = today(getLocalTimeZone());
  const yesterday = currentDate.add({ days: -1 });
  const currentMonthStartDate = currentDate.set({ day: 1 });
  const previousMonthEndDate = currentMonthStartDate.add({ days: -1 });
  const previousMonthStartDate = previousMonthEndDate.set({ day: 1 });
  const currentQuarterStartMonth =
    Math.floor((currentDate.month - 1) / 3) * 3 + 1;
  const currentQuarterStartDate = currentDate.set({
    month: currentQuarterStartMonth,
    day: 1,
  });
  const previousQuarterEndDate = currentQuarterStartDate.add({ days: -1 });
  const previousQuarterStartDate = previousQuarterEndDate
    .set({ day: 1 })
    .add({ months: -2 });
  const lastSixMonthsStartDate = currentMonthStartDate.add({ months: -6 });
  const currentYearStartDate = currentDate.set({ month: 1, day: 1 });
  const previousYearEndDate = currentYearStartDate.add({ days: -1 });
  const previousYearStartDate = previousYearEndDate.set({ month: 1, day: 1 });

  return [
    {
      key: 'today',
      label: 'Today',
      value: { start: currentDate, end: currentDate },
    },
    {
      key: 'yesterday',
      label: 'Yesterday',
      value: {
        start: yesterday,
        end: yesterday,
      },
    },
    {
      key: 'last_week',
      label: 'Last week',
      value: {
        start: currentDate.add({ days: -7 }),
        end: currentDate.add({ days: -1 }),
      },
    },
    {
      key: 'last_month',
      label: 'Last month',
      value: { start: previousMonthStartDate, end: previousMonthEndDate },
    },
    {
      key: 'last_quarter',
      label: 'Last quarter',
      value: {
        start: previousQuarterStartDate,
        end: previousQuarterEndDate,
      },
    },
    {
      key: 'last_6_months',
      label: 'Last 6 months',
      value: {
        start: lastSixMonthsStartDate,
        end: previousMonthEndDate,
      },
    },
    {
      key: 'last_year',
      label: 'Last year',
      value: {
        start: previousYearStartDate,
        end: previousYearEndDate,
      },
    },
  ];
}
